import lf from 'lovefield'

export function simu_installations (schemaBuilder) {
  schemaBuilder.createTable('simu_installations')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_etudes_id', lf.Type.INTEGER)
      .addColumn('pk', lf.Type.INTEGER)
      .addColumn('debut', lf.Type.DATE_TIME)
      .addColumn('fin', lf.Type.DATE_TIME)
      .addColumn('valide', lf.Type.INTEGER)
      .addPrimaryKey(['id'], true)
      .addNullable(['debut', 'fin', 'pk', 'valide']);

}

/*
CREATE TABLE IF NOT EXISTS `simu-installations` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-etudes_id` int(11) NOT NULL,
  `pk` int(11) NOT NULL COMMENT 'en mètres',
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuInstallations.schema.js